// extracted by mini-css-extract-plugin
export default {"textWrapper":"header_textWrapper__heZan","title":"header_title__j5wSX","info":"header_info__hh43I"};